import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const uploadUserDocument = async (user, id, file, type, fileName) => {
    try {
        const { data } = await axios.post(`${API_BASE_URL}/users/clients/${id}/upload-document?type=${type}`, { data: file, type, fileName },
            buildHeaders(user))
        return data;
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const deleteUserDocument = async (user, id, key) => {
    try {
        const { data } = await axios.post(`${API_BASE_URL}/users/clients/${id}/delete-document`, { key },
            buildHeaders(user))
        return data;
    } catch (error) {
        console.error(error)
        throw error
    }
}